<script lang="ts" module>
  import { type tagId, type primitive, entryTitle } from './FilterRow.utils';
  import { mapOpt } from '#lib/overview/utils/object.js';
  import type { ClassValue } from 'svelte/elements';

  const identity = (x: any) => x;
</script>

<script lang="ts">
  interface Props {
    id: tagId;
    options: Array<{
      title?: string;
      value: primitive;
      active?: boolean;
    }>;
    tagLabel?: (tagTitle: string) => string;
    tagTitle?: (tagTitle: string) => string;
    onClick?: (e: {
      id: tagId;
      value: primitive;
      active: boolean;
      mode: 'replace' | 'toggle';
    }) => void;
    class?: ClassValue;
  }

  let {
    id,
    options,
    tagLabel = identity,
    tagTitle = identity,
    onClick,
    class: className,
  }: Props = $props();

  let anyActive = $derived(options.some((o) => o.active));
</script>

<div class={['border-table-border input flex w-fit items-center p-2 pl-4', className]}>
  <span>{entryTitle(id)}:</span>
  {#each options as opt, i (i)}
    <button
      class={[
        'tooltip tooltip-bottom tooltip-custom',
        'btn btn-xs mx-1 rounded-full px-2 py-1',
        !anyActive ? 'btn-primary btn-outline' : opt.active ? 'btn-primary' : 'btn-outline',
      ]}
      data-tag={opt.title ?? opt.value}
      onclick={(e) =>
        onClick?.({
          id,
          value: opt.value,
          active: opt.active === true,
          mode: e.ctrlKey ? 'toggle' : 'replace',
        })}
      data-tip={tagTitle(String(opt.value)) || String(opt.value)}
    >
      {@html mapOpt(opt.title, tagLabel) ?? opt.value}
    </button>
  {/each}
</div>

<style>
  .tooltip-custom {
    --tt-bg: var(--color-base-300);
  }

  .tooltip-custom::before {
    font-weight: lighter;
  }
</style>
